export class BeanDestinatarios{
  constructor(
    public idDeopCdDestoper: number,
    public operIdCdOperacao  : number,
    public idTideCdTipoDestinatario  : number,
    public deopDsDestinatario	 : string,
    public deopDhInclusao : string,
    public deopDhInativo	 : string

  ){}
}
